import {
  TabView as BaseTabView,
  TabDefinition,
} from '@features/campaigns/components/TabView';
import { SummaryContainer } from './Summary/SummaryContainer';
import { RealTimeOptimizationContainer } from './RealTimeOptimization/RealTimeOptimizationContainer';
import { CampaignAnalytics } from './CampaignAnalytics';
import { useCurrentCampaign } from '../hooks/useCampaign';

export const TabView = () => {
  const { campaign } = useCurrentCampaign();

  const tabs: TabDefinition[] = [
    {
      label: 'Campaign Summary',
      component: <SummaryContainer />,
      path: 'summary',
    },
    {
      label: 'Real-Time Optimization',
      component: <RealTimeOptimizationContainer />,
      path: 'real-time-optimization',
    },
    ...(campaign?.campaignType === 'rslvisits'
      ? [
          {
            label: 'Campaign Analytics',
            component: <CampaignAnalytics />,
            path: 'campaign-analytics',
          } satisfies TabDefinition,
        ]
      : []),
  ];

  return <BaseTabView tabs={tabs} />;
};
